import { memo } from 'react';

import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { Typography } from '@mui/material';

import { IRadioOptionProps } from '../../../constants/types';

const RadioOption = memo(
  ({ options, value = null, setAnswer }: IRadioOptionProps) => {
    const handleChange = (
      event: React.ChangeEvent<HTMLInputElement> | React.MouseEvent
    ) => {
      setAnswer((event.target as HTMLInputElement).value);
    };

    return (
      <FormControl data-testid="radio-option-component">
        <RadioGroup
          className="button-radio-group"
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={value}
        >
          {options?.map((option: string) => (
            <FormControlLabel
              key={option}
              value={option}
              control={<Radio onClick={handleChange} />}
              label={
                <Typography variant="h6" sx={{ color: 'primary.main' }}>
                  {option} {option === 'Yes' ? '👍' : '👎'}
                </Typography>
              }
            />
          ))}
        </RadioGroup>
      </FormControl>
    );
  }
);

export default RadioOption;
